import { Component, Input, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { HierarchyTab } from './hierarchy-tabs.model';

@Component({
  selector: 'ov-suite-hierarchy-tabs',
  templateUrl: './hierarchy-tabs.component.html',
  styleUrls: ['./hierarchy-tabs.component.scss'],
})
export class HierarchyTabsComponent implements OnInit {
  active: string;

  @Input() tabs: HierarchyTab[] = [];

  highlightColor = '#009de6';

  constructor(private readonly router: Router) {}

  ngOnInit() {
    // set initial value
    if (this.router.url.includes('?')) {
      this.active = this.router.url.split('?')[0];
      if (this.active.split('/').length > 1) {
        this.active = `/${this.active.split('/')[1]}`;
      }
    } else {
      this.active = `${this.router.url}`;
    }
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        if (event.url.includes('?')) {
          this.active = event.url.split('?')[0];
        } else {
          this.active = `/${event.url.split('/')[1]}`;
        }
      }
    });

    // dynamic highlight color changer
    // @ts-ignore
    const [element] = document.getElementsByClassName('sidebar');
    if (element) {
      const className = element.getAttribute('data-active-color');
      const style = getComputedStyle(document.body);
      const hexColor = style.getPropertyValue(`--${className}`).trim();
      if (hexColor) {
        this.highlightColor = hexColor;
      }
    }
  }

  ignoreSubBath(path: string) {
    return `/${path.split('/')[1]}`;
  }
}
